/** Shared brand palette for button components (aligned with acmeTheme) */
export const BRAND_PRIMARY = '#22c55e';
export const BRAND_PRIMARY_HOVER_DARK = '#16a34a';
export const BRAND_PRIMARY_HOVER_LIGHT = '#4ade80';
export const BRAND_ACCENT = '#22c55e';
export const BRAND_ACCENT_HOVER = '#16a34a';
